// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__hG6zi","fullScreen":"style_fullScreen__jJCYx","hidden":"style_hidden__2duru"};